/* @flow */

// Feature flags are serialised into the page by FormClientConfigHelper and read
// lazily so that callers always see the flags for the currently rendered form.
export const formFeatures = (): { [string]: boolean } => {
  const formConfig = document.querySelector("#formConfig") || {};

  try {
    return JSON.parse(formConfig.textContent || "{}").features || {};
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("Failed to parse formConfig", e);
    return {};
  }
};
